import React, { CSSProperties, PropsWithChildren } from 'react';

interface SectionProps extends PropsWithChildren {
  style?: CSSProperties;
  className?: string;
  bgClassName?: string;
}

const Section = (props: SectionProps) => {
  const backgroundClass = props.bgClassName
    ? `${classNames.background} ${props.bgClassName}`
    : classNames.background;
  return (
    <div className={backgroundClass}>
      <div
        style={props.style}
        className={
          props.className
            ? `${classNames.container} ${props.className}`
            : classNames.container
        }
      >
        {props.children}
      </div>
    </div>
  );
};

const classNames = {
  background: ['tw-flex', 'tw-self-stretch', 'tw-justify-center'].join(' '),
  container: [
    'tw-flex',
    'tw-flex-col',
    'tw-mx-[16px]',
    'md:tw-mx-[80px]',
    'xl:tw-mx-0',
    'lg:tw-max-w-[1128px]',
    'tw-my-[48px]',
    'md:tw-my-[80px]',
    'xl:tw-my-[120px]',
  ].join(' '),
};
export { Section };
export type { SectionProps };
